<template>
  <div v-if="payStatus===0"
    style="text-align:center;font-size: 20px;display:flex;justify-content:center;align-items:center;height:100vh;width:100vw;">
    支付跳转中...
  </div>
  <div v-else-if="payStatus===1"
       style="text-align:center;font-size: 20px;display:flex;justify-content:center;align-items:center;height:100vh;width:100vw;">
    支付成功
  </div>
  <div v-else-if="payStatus===2"
    style="text-align:center;font-size: 20px;display:flex;justify-content:center;align-items:center;height:100vh;width:100vw;">
    支付失败
  </div>
</template>

<script>

export default {
  data() {
    return {
      orderId: null,
      payMode: null,
      qrData: "",
      dateUnit: '',
      payStatus: 0,
      paySuccessUrl: null,
      payFailUrl: null,
    };
  },
  created() {
    this.init()
  },

  methods: {
    init() {
      this.orderId = this.getUrlParams('orderId')
      this.code = this.getUrlParams('code')
      console.log('code: ' + this.code + ', orderId:' + this.orderId)
      if (this.orderId && this.code) {
        this.createOrder()
      }
    },
    getUrlParams(name) {
      // 获取当前URL
      const url = window.location.href;
      // 创建一个URL对象
      const urlObj = new URL(url);
      // 获取所有参数
      const params = urlObj.searchParams;
      // 返回指定参数的值
      return params.get(name);
    },
    createOrder() {
      const _this = this
      const params = {
        'code': this.code,
        'id': this.orderId,
        'payMode': 42
      }
      _this.$post("pay/weComPay", params)
        .then(response => {
          console.log('请求响应：' + response)
          _this.paySuccessUrl = response.data.paySuccessUrl
          _this.payFailUrl = response.data.payFailUrl
          if (response.code === 0) {
            if (response.data.paySign) {
              // 唤起支付
              _this.wechatPay(response.data)
            } else {
              _this.payStatus = 2
              _this.payFail()
            }
          } else {
            _this.payStatus = 2
            alert(response.msg)
            _this.payFail()
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试。" + err)
          _this.payFail()
        });
    },

    wechatPay(params) {
      const _this = this
      // if (typeof WeixinJSBridge == "undefined") {
      //   if (document.addEventListener) {
      //     document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false);
      //   } else if (document.attachEvent) {
      //     document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data));
      //     document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data));
      //   }
      // } else {
      //   this.onBridgeReady(data);
      // }

      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          //小程序环境 ,在此进行相关逻辑处理
          const packageStr = "prepay_id=" + params.prepayId
          const paramJson = '{"timeStamp":"' + params.timestamp + '","signType": "RSA","nonceStr":"'+ params.nonce +
            '","package":"' + packageStr + '","paySign":"' + params.paySign + '","paySuccessUrl":"' + params.paySuccessUrl + '","payFailUrl":"' + params.payFailUrl + '"}'
          wx.miniProgram.redirectTo({
            url: "/pages/webview/index?detail=" + encodeURIComponent(paramJson)
          })
        } else {
          //非小程序环境下逻辑
          alert('非小程序环境，支付失败！')
          _this.payFail()
          console.log('不在小程序中')
        }
      })
    },


    // onBridgeReady() {
    //   const _this = this
    //   alert('微信支付')
    //   console.log('微信支付环境已准备好：')
    //   WeixinJSBridge.invoke('getBrandWCPayRequest', {
    //           "timeStamp": '1741252158',   //时间戳，自1970年以来的秒数
    //           "appId": 'wxbfa86ae7b42fc2fe',     //公众号ID，由商户传入
    //           "nonceStr":  '1741252158982',      //随机串
    //           "package": "prepay_id=" + 'wx0617091975796942fcf99d181a827c0000',
    //           "signType": "RSA",     //微信签名方式：
    //           "paySign": 'Tsd2aKvawKHUlbZrkpw9UaBZ7F+ls8wmbKNL3EqxddTnk9Vg+WELrjY77DdIIzl5bpZRleLxm3Awc5cIaHp4nJNey6TPDxOcIJpEL6P3UyX/jb6ufrpGy8X0CFZOWyad1spnRZhCWqLyH6UF2Vb0YjUkNd2L2BHg+/73YJAJ5blREHlfu+yTWhZ5K9jULiCn7hfbl8h33L3sddpPeRBgF4RF2fINWJOiXwdwL6Xs+fTrQszoN7jwPnQLnUsiUP99/L0gibrcg1HbMr5TcMijcD2XD/huv6OEI/UT+qfSy0atn0rNJReWpmb1KFmQylQ02SJAZ2k0IhioXGP5pt+jWg=='
    //       },
    //       function(res) {
    //           if (res.err_msg == "get_brand_wcpay_request:ok") {
    //               // 使用以上方式判断前端返回,微信团队郑重提示：
    //               //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠，商户需进一步调用后端查单确认支付结果。
    //             _this.payStatus = 1
    //             _this.paySuccess()
    //           } else {
    //             console.log('res:' + res)
    //             if (res.err_no) {
    //               alert('err_no'+ res.err_no)
    //             }
    //             if (res.err_msg) {
    //               alert('err_msg'+ res.err_msg)
    //             }
    //             _this.payStatus = 2
    //             _this.payFail()
    //           }
    //       });
    // },

    paySuccess() {
      if (this.paySuccessUrl) {
        window.location.href = this.paySuccessUrl;
      }

    },
    payFail() {
      if (this.payFailUrl) {
        window.location.href = this.payFailUrl;
      }
    },
  },
  filters: {},
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/pages/pay/QiYeWeiXinPay.vue